import { NextResponse } from 'next/server'

const contentType = "image/svg+xml"
const cacheControl = "public, max-age=0, must-revalidate"
const buffer = Buffer.from("PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCIgZmlsbD0ibm9uZSI+CiAgPCEtLSBCYWNrIGZhY2UgKGRhcmtlciByZWQpIC0tPgogIDxwYXRoIGQ9Ik0zMiA4TDU2IDIyVjQ2TDMyIDYwTDggNDZWMjJMMzIgOFoiIGZpbGw9IiNDNDE4MjAiLz4KICA8IS0tIExlZnQgZmFjZSAtLT4KICA8cGF0aCBkPSJNOCAyMkwzMiAzNlY2MEw4IDQ2VjIyWiIgZmlsbD0iI0UxMUQyNCIvPgogIDwhLS0gUmlnaHQgZmFjZSAtLT4KICA8cGF0aCBkPSJNNTYgMjJMMzIgMzZWNjBMNTYgNDZWMjJaIiBmaWxsPSIjQjAxQTIwIi8+CiAgPCEtLSBUb3AgZmFjZSAtLT4KICA8cGF0aCBkPSJNOCAyMkwzMiA4TDU2IDIyTDMyIDM2TDggMjJaIiBmaWxsPSIjRkYyRDM1Ii8+CiAgPCEtLSBJbm5lciBjdWJlIGN1dG91dCAoY3JlYXRlcyB0aGUgM0Qgb3Blbi1ib3ggZWZmZWN0KSAtLT4KICA8cGF0aCBkPSJNMzIgMjJMMjAgMjhWNDBMMzIgNDZMNDQgNDBWMjhMMzIgMjJaIiBmaWxsPSIjMEEwQTBBIi8+CiAgPCEtLSBJbm5lciBsZWZ0IC0tPgogIDxwYXRoIGQ9Ik0yMCAyOEwzMiAzNFY0NkwyMCA0MFYyOFoiIGZpbGw9IiMxQTFBMUEiLz4KICA8IS0tIElubmVyIGJvdHRvbSAtLT4KICA8cGF0aCBkPSJNMzIgMzRMNDQgMjhWNDBMMzIgNDZWMzRaIiBmaWxsPSIjMTExMTExIi8+Cjwvc3ZnPgo=", 'base64')

export function GET() {
    return new NextResponse(buffer, {
        headers: {
            'Content-Type': contentType,
            'Cache-Control': cacheControl,
        },
    })
}

export const dynamic = 'force-static'
